import { onBeforeUnmount } from 'vue';

export default function useStopOverflow(persist = false) {
  const preventOverflow = () => {
    if (import.meta.env.SSR) {
      return;
    } else {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    }
  };
  const resetOverflow = () => {
    if (import.meta.env.SSR) {
      return;
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    }
  };

  if (!persist) {
    onBeforeUnmount(() => {
      resetOverflow();
    });
  }

  return {
    preventOverflow,
    resetOverflow,
  };
}
